import * as React from 'react'
// @ts-ignore
import { Button } from 'relevant-ui'
import './styles.scss'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
// @ts-ignore
import SEARCH from 'assets/search.svg'
import { connect } from 'react-redux'
import { toggleFieldAction } from '@App/store/toggleField'
import classnames from 'classnames'

class ButtonWrapper extends React.Component<any> {
  constructor(props: any) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const { toggle, toggleFieldAction, onSubmit, dataTable } = this.props

    e.preventDefault()

    if (toggle) {
      return toggleFieldAction(false)
    }
    return onSubmit(e, dataTable)
  }

  render() {
    const { t, toggle, onCancel, onDelete, current, disabled } = this.props

    return (
      <div
        className={classnames(
          'buttonWrapper',
          current && toggle && 'buttonWrapper--current',
        )}
      >
        {current && toggle && (
          <Button
            label={t('delete')}
            size="large"
            type="text"
            button="primary"
            onClick={(e: any) => onDelete(e)}
          />
        )}
        <div>
          {!toggle && (
            <Button
              label={t('cancel')}
              size="large"
              type="button"
              button="secondary"
              onClick={onCancel}
            />
          )}
          <Button
            label={!toggle ? t('validate') : t('update')}
            size="large"
            type="submit"
            button="primary"
            onClick={(e: any) => this.handleClick(e)}
            disabled={!toggle ? disabled : false}
          />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    toggleFieldAction: (bool: boolean) => dispatch(toggleFieldAction(bool)),
  }
}

const mapStateToProps = (state: any) => {
  const {
    toggleFields: { toggle },
    applications: { current },
  } = state

  return {
    toggle,
    current,
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(ButtonWrapper)
